<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Detalle de Devolción Folio. {{ compra.folio }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{compra.provider}}</h6>
          <div class="card mt-5">
            <div class="card-header row">
                <div class="col-lg-6">Información General</div>
                <!-- <div class="text-right col-lg-6">
                    <button @click="editarInfo">editar</button>
                </div> -->
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 text-center">
                  <h6>Cantidad de productos</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Total de compra</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Fecha de compra</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Registro</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.cantidad }}</b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b><span v-html="getFormattedAmount(compra.total)" /></b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.create_at }}</b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.user_name }}</b></div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Relacion de productos devueltos
              <div class="row justify-content-end">
                <button class="btn btn-purple mr-4" @click="printCompra">Imprimir reporte</button>
                <button class="btn btn-danger" @click="cancelFolio" v-if="mostrarCancelFolio && myRoleId === 1">Cancelar Folio de Devolución</button>
              </div>
            </div>
            <!-- {{tickets}} -->
            <div class="card-body">
              <b-table
                striped
                selectable
                class="table-adelantazo"
                select-mode="multi"
                selectedVariant="success"
                responsive="sm"
                show-empty
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @row-selected="onRowSelected"
              >
                 <template v-slot:cell(fullname)="row">
                  <div align="center" class="history-amount">
                    <span style="font-size: 10px">{{row.item.fullname}}</span>
                  </div>
                </template>
                <template v-slot:cell(precio)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.precio)" />
                  </div>
                </template>
                <template v-slot:cell(descuento)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.descuento)" />
                  </div>
                </template>
                <template v-slot:cell(costo_tienda)="row">
                  <div align="center" class="history-amount">
                    <span style="color: green" v-html="getFormattedAmount(row.item.costo_tienda)" />
                  </div>
                </template>
                <template v-slot:cell(venta)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.venta)" />
                  </div>
                </template>
                <template v-slot:cell(porcentaje_descuento)="row">
                  <div align="center" class="history-amount">
                     <span>{{row.item.porcentaje_descuento}} %</span>
                  </div>
                </template>
                <template v-slot:cell(porcentaje_descuento_nosotros)="row">
                  <div align="center" class="history-amount">
                     <span>{{row.item.porcentaje_descuento_nosotros}} %</span>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div align="center" class="history-amount">
                    <button class="btn btn-danger" @click="cancelOrder(row)" v-if="row.item.status !== 'CANCELADO' && myRoleId === 1">Cancelar</button>
                  </div>
                </template>
              <!-- <div slot="RequestDate" slot-scope="row">{{ row }}</div> -->
            </b-table>
            </div>
          </div>

        </div>
      </div>
    </div>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="letter"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item labelsComplete">
            <div class="etiqueta col" v-for="item in tickets" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center mt-1' : 'row justify-content-center']">
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="40" width="1" font-size="10"/>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left">
                  <p><b>{{item.key_client}}</b> - {{item.name}} {{item.lastname}} {{item.lastname2}} </p>
                  <p><b>{{item.siglas}}</b> - {{item.marca}} - {{item.model}} - {{item.color}} - {{item.numero}}</p>
                  <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="reporte"
      >
        <section slot="pdf-content">
          <section class="pdf-item">
            <div class="printCompra">
              <div class="container">
                <div class="row mt-5">
                  <div class="col-lg-12">
                    FOLIO: {{ compra.folio }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    Fecha de compra: {{ compra.create_at }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    Tienda: {{compra.name}}
                  </div>
                  <div class="col-lg-6">
                    Usuario que registro: {{ compra.user_name }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    Proveedor: {{ compra.provider }}
                  </div>
                </div>
                <div class="row justify-content-center mt-3">
                  Total de compra: $ {{ compra.total | formatNumberCurrency }}
                </div>
                <div class="row justify-content-center mt-5">
                  <div class="title">Relacion de productos</div>
                </div>
                <div class="row justify-content-center mt-5">
                  <table class="col-11">
                    <colgroup span="4" class="columns">LISTADO DE PRODUCTOS</colgroup>
                    <tr class="text-center">
                      <th>Cantidad</th>
                      <th>Codigo de Barras</th>
                      <th>Cliente</th>
                      <th>Producto</th>
                      <th>Costo Tienda</th>
                    </tr>
                    <tr v-for="item in items" :key="item.id_order">
                      <td class="text-center">{{ item.cantidad }}</td>
                      <td class="text-center">{{ item.barcode}}</td>
                      <td class="text-center">{{ item.cliente}}</td>
                      <td class="text-center">{{ item.producto}}</td>
                      <td class="text-center">$ {{ item.costo_tienda | formatNumberCurrency}}</td>
                    </tr>
                    <tr>
                      <td colspan="3" class="text-right">Total Devuelto:  </td>
                      <td class="text-center">$ {{ compra.total | formatNumberCurrency }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { BTable } from 'bootstrap-vue'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'

export default {
  mixins: [formatData],
  components: {
    BTable,
    VueHtml2pdf,
    VueBarcode
  },
  data () {
    return {
      totalCancelados: 0,
      barcode_option: {
        // height="18" width="2" font-size="10"
        // format: 'EAN13',
        // lineColor: '#0aa',
        // height: 35
        format: 'pharmacode',
        lineColor: '#0aa',
        width: 1,
        height: 15,
        displayValue: false
      },
      htmlToPdfOptions: {
        margin: [10, 0, 10, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      },
      htmlToPdfOptions2: {
        margin: 0,
        filename: 'hehehe.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      selected: [],
      compra: null,
      items: [],
      fields: [
        { key: 'barcode', label: 'Codigo de barras', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'producto', label: 'Producto', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'cliente', label: 'Cliente', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'costo_tienda', label: 'Costo tienda', thClass: 'text-center', tdClass: 'rowTable text-right' },
        { key: 'status', label: 'Estatus', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      tickets: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    },
    mostrarCancelFolio () {
      let x = true
      if (this.totalCancelados === this.items.length) {
        x = false
      }
      return x
    },
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    onRowSelected (items) {
      this.selected = items
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN') + ' <span class="mxn">MXN</span>'
      } else {
        return ''
      }
    },
    async cancelFolio () {
      try {
        const request = {
          orders: this.items,
          folio: this.compra.folio,
          enterprise: this.user.enterprise_id
        }
        const cancel = await axiosAdelaService.post('/cancelFolioProviderDevolution', request)
        console.log('abonnos', cancel)
        if (cancel.status === 200) {
          this.$toastedPush({
            message: 'Devolucion Cancelada correctamente',
            type: 'success'
          })
          this.getDetailBuy()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async cancelOrder (order) {
      try {
        console.log(order)
        const request = {
          order_id: order.item.order_id,
          folio: order.item.folio,
          enterprise: this.user.enterprise_id
        }
        const cancel = await axiosAdelaService.post('/cancelDevolutionProviderOrder', request)
        console.log('abonnos', cancel)
        if (cancel.status === 200) {
          this.$toastedPush({
            message: 'Devolucion Cancelada correctamente',
            type: 'success'
          })
          this.getDetailBuy()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async updateInfo () {
      try {
        const requestAbonos = {
          function: 'UpdateInfoClient',
          name: this.editInfo.name,
          lastname1: this.editInfo.lastname1,
          lastname2: this.editInfo.lastname2,
          phone: this.editInfo.phone,
          address: this.editInfo.address,
          email: this.editInfo.email,
          id_client: this.data.id_client
        }
        const params = await this.toFormData(requestAbonos)
        const abonos = await axiosAdelaService.post('/', params)
        console.log('abonnos', abonos)
        if (abonos.status === 200) {
          this.$toastedPush({
            message: 'Cliente actualizado',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getDetailBuy () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          folio: this.compra.folio
        }
        console.log('request getDetailDevolutionProvider', request)
        const orders = await axiosAdelaService.post('/getDetailDevolutionProvider', request)
        console.log('* * * ***** getDetailDevolutionProvider', orders)
        if (orders.status === 200) {
          console.log(orders)
          this.items = orders.data.rows
          this.items.forEach(el => {
            if (!el.active) {
              el._rowVariant = 'danger'
              this.totalCancelados++
            }
            el.status = el.active ? 'Devuelto' : 'CANCELADO'
          })
        }
      } catch (error) {
        console.log('error getDetailDevolutionProvider', error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async printEtiquetas () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        console.log('parametros,printEtiquetas', params)
        const response = await axiosAdelaService.post('/getBarcodesforBarcode', params)
        console.log('getBarcodesforBarcode', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            data[key].date_buy = moment(data[key].date_buy).format('YYYY-MM-DD')
            this.tickets.push(data[key])
          }
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async printCompra () {
      try {
        console.log()
        this.$refs.reporte.generatePdf()
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    try {
      await this.getDetailBuy()
    } catch (error) {
      console.log('error mounted', error)
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  },
  created () {
    this.compra = this.$_.get(this.$route, 'params.item', {})
    console.log('Compra detalle', this.compra)
  }
}
</script>
<style>
.rowTable {
  font-size: 12px;
}
.etiqueta {
    width: 60mm !important;
    height: 22mm !important;
    /* background: red; */
    padding: 0px !important;
  }
  .etiqueta svg {

  }
  .labels {
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    /* width: 60mm; */
    font-size: 11px;
    font-weight: 900;
    margin: auto;
  }
  .labels p {
    line-height: 1;
    margin: 0;
  }
  .endLabels {
    font-size: 8px;
  }
  .labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  /* grid-auto-rows: minmax(66mm, auto); */
  }
  .printCompra {
    color: black;
  }
  th, td {
  border-bottom: 1px solid #ddd;
}
</style>
